import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FlexWrapper, SPACINGS} from '@qadra/frontend-common-ts';
import { Card, Alert, Button, Form, FormInput } from '@qadra/frontend-common/atoms';
import { Row, Col } from '@qadra/frontend-common/grid';
import { connect, push } from '@qadra/frontend-common/redux';
import { validations } from '@qadra/frontend-common/validations';
import { Paragraph, Heading } from '@qadra/frontend-common/typography';
import { FORGOT } from '../redux/actions';
import { withTranslate } from '../utils/translations';
import { ClientConfigContext } from '../contexts/ClientConfigContext';
import { paths } from '../utils';

class PasswordForgot extends Component {
  static contextType = ClientConfigContext;
  doSendLink = ({ Email }) => {
    this.props.onSendLink({
      Email,
    });
  };

  gotoLogin = () => this.props.pushUrl(paths.login);

  render() {
    const { t, error, emailSent } = this.props;
    const { bgColor } = this.context || {};
    return (
      <>
        {error && (
          <Alert style={{ marginBottom: 50 }} type="danger">
            {error}
          </Alert>
        )}
          <Card style={{ width: '100%', maxWidth: '600px', marginBottom: 0, border: 'none' }}>
            <Row>
              <Col xs={12}>
                <FlexWrapper style={{width: '100%'}} justify='center'>
                  <Heading type={2}>
                    {emailSent ? t('sso.passForgot.titleSuccess') : t('sso.passForgot.title')}
                  </Heading>
                </FlexWrapper>
              </Col>
              <Col xs={12}>
                <Paragraph>
                  {emailSent ? t('sso.passForgot.subTitleSuccess') : t('sso.passForgot.subTitle')}
                </Paragraph>
              </Col>
            </Row>
            {!this.props.emailSent && (
              <Row style={{marginTop: SPACINGS[12]}}>
                <Col>
                  <Form innerRef={(r) => (this.form = r)} onSubmit={this.doSendLink}>
                    <FormInput
                      label="Email"
                      name="Email"
                      type="email"
                      initialValue=""
                      required
                      pattern={validations.email.reg}
                      patternErr={validations.email.error}
                    />
                  </Form>
                </Col>
              </Row>
            )}
            <Row>
              <FlexWrapper style={{width: '100%', marginTop: SPACINGS[30]}} justify='center'>
                <Button style={{width: '300px', paddingLeft: '110px', backgroundColor: bgColor, borderColor: bgColor}}
                  label={emailSent ? t('sso.passForgot.buttonSuccess') : t('sso.passForgot.button')}
                  onClick={emailSent ? this.gotoLogin : () => this.form.submitForm()}
                />
              </FlexWrapper>
            </Row>
          </Card>
      </>
    );
  }
}

PasswordForgot.propTypes = {
  onSendLink: PropTypes.func,
  pushUrl: PropTypes.func,
  error: PropTypes.string,
  emailSent: PropTypes.bool,
};

export default withTranslate(
  connect(
    (state) => ({
      error: state.forgot.error,
      emailSent: state.forgot.emailSent,
    }),
    (dispatch) => ({
      pushUrl: (url) => dispatch(push(url)),
      onSendLink: (payload) =>
        dispatch({
          type: FORGOT._REQUEST,
          payload,
        }),
    })
  )(PasswordForgot)
);
